<template>
  <document-list :config="config" :isLoading="isLoading" :height="height"></document-list>
</template>

<script>
import DocumentList from './DocumentList';
import loaderMixin from '@/mixins/loaderMixin';
export default {
  mixins: [loaderMixin],
  name: 'ToRead',
  props: {
    config: Object,
    height: Number, // optional height of this widget
  },
  components: {
    DocumentList,
  },
  created() {
    this.config.unreadOnly = true;
  },
};
</script>
